import React from 'react';
import { Tooltip } from 'antd';

import { NOT_READABLE_LABEL, NOT_READABLE_TOOLTIP } from '../../utils/linkedRecords';

/**
 * A lookup reference this reader can no longer open — the tombstone a
 * collection link leaves when it ends without copies (keepr-api § Lookups
 * across a link: the id stays, the batch resolve lists it in
 * `X-Not-Readable`). Muted, never a link, and it says why on hover. The
 * same id resolves again if the link comes back, and the chip goes with it.
 */
export default function LookupUnavailable({ className = '' }) {
	return (
		<Tooltip title={NOT_READABLE_TOOLTIP}>
			<span
				className={['lookup-unavailable', className].filter(Boolean).join(' ')}
				data-testid="lookup-unavailable"
				aria-label={`${NOT_READABLE_LABEL}: ${NOT_READABLE_TOOLTIP}`}
			>
				{NOT_READABLE_LABEL}
			</span>
		</Tooltip>
	);
}
